import React from 'react';
import styled from 'styled-components';
import {
  FaCcAmex,
  FaCcMastercard,
  FaCcDinersClub,
  FaCcVisa,
  FaCcDiscover,
  FaCcJcb,
} from 'react-icons/fa';
import { UnionPaySVG } from '@bb/elements-web';

type CreditCardType = keyof typeof creditCardIconMap;

/** A container to make the UnionPay icon look like all the others. */
const Container = styled.div`
  filter: grayscale(1);
  height: 20px;
  transform-origin: 0 0;
  transform: scale(0.12) translate(0, -30px);
  width: 36px;
`;

/** Give a consistent size to all the credit card logos */
const CreditCardLogo = styled.div<{ $size?: number }>`
  font-size: ${props => props.$size || 25}px;
  margin-bottom: -7px;
`;

const UnionPayIcon = () => (
  <Container>
    <UnionPaySVG />
  </Container>
);

const creditCardIconMap = {
  visa: <FaCcVisa />,
  mastercard: <FaCcMastercard />,
  amex: <FaCcAmex />,
  'american express': <FaCcAmex />,
  diners: <FaCcDinersClub />,
  discover: <FaCcDiscover />,
  jcb: <FaCcJcb />,
  unionpay: <UnionPayIcon />,
};

const creditCardNameMap = {
  visa: 'Visa',
  mastercard: 'MasterCard',
  amex: 'American Express',
  'american express': 'American Express',
  diners: 'Diners Club',
  discover: 'Discover',
  jcb: 'JCB',
  // UnionPayIcon defined above
  unionpay: 'UnionPay',
};

/** Ensure the passed in string is one we have an icon for. */
const isCreditCardType = (type: string): type is CreditCardType =>
  Object.keys(creditCardIconMap).includes(type);

/** A function to render the logo for a credit card depending on the name sent in. */
export const renderCreditCardIcon = (
  type: string,
  size?: number,
): React.ReactElement => {
  const lowerCaseType = type.toLowerCase().trim();
  return (
    <CreditCardLogo $size={size}>
      {isCreditCardType(lowerCaseType) ? (
        creditCardIconMap[lowerCaseType]
      ) : (
        <span>?</span>
      )}
    </CreditCardLogo>
  );
};

/** A function to render the title for a credit card depending on the type sent in. */
export const renderCreditCardName = (type: string): string => {
  const lowerCaseType = type.toLowerCase().trim();
  return isCreditCardType(lowerCaseType)
    ? creditCardNameMap[lowerCaseType]
    : '';
};
